import { Helmet } from "react-helmet-async";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { WhyChoose } from "@/components/site/WhyChoose";
import { Process } from "@/components/site/Process";
import { Realisaties } from "@/components/site/Realisaties";
import { Reviews } from "@/components/site/Reviews";
import { TeamFleet } from "@/components/site/TeamFleet";
import { Region } from "@/components/site/Region";
import { CTASection } from "@/components/site/CTASection";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { MobileCallBar } from "@/components/site/MobileCallBar";
import { useLang, homePath } from "@/i18n/LangContext";
import { SITE } from "@/constants/vhm";

export default function Home() {
  const { t, lang } = useLang();
  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description} />
        <link rel="canonical" href={`${SITE.domain}${homePath(lang) === "/" ? "/" : homePath(lang)}`} />
        <link rel="alternate" hrefLang="nl" href={`${SITE.domain}/`} />
        <link rel="alternate" hrefLang="fr" href={`${SITE.domain}/fr`} />
        <link rel="alternate" hrefLang="en" href={`${SITE.domain}/en`} />
        <link rel="alternate" hrefLang="es" href={`${SITE.domain}/es`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE.domain}/`} />
        <meta property="og:title" content={t.meta.title} />
        <meta property="og:description" content={t.meta.description} />
        <meta property="og:url" content={`${SITE.domain}${homePath(lang) === "/" ? "/" : homePath(lang)}`} />
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyChoose />
        <Process />
        <Realisaties />
        <Reviews />
        <TeamFleet />
        <Region />
        <CTASection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileCallBar />
    </>
  );
}
